module.exports = __webpack_public_path__ + "img/people.1ed70967.svg";